import React, { Component } from 'react';
import PropTypes from 'prop-types'; // ES6

import fotoNoTrobada from '../../images/fotoNoTrobada.jpg';

class ImatgeAmbControlError extends Component {

    constructor(props) {
        super(props);
        this.onErrorImg = this.onErrorImg.bind(this);
        this.state = {
            hiHaError: false
        };
    }

    onErrorImg() {
        if (!this.state.hiHaError) {
            this.setState({hiHaError: true});
        }
    }

    render() {
        const { url, classNameImg } = this.props;
        const { hiHaError } = this.state;

        const urlImatge = (hiHaError) ? fotoNoTrobada : url;

        return (
            <img
                src={urlImatge}
                alt={''}
                onError={this.onErrorImg}
                className={classNameImg}
            />
        );
    }
}

ImatgeAmbControlError.propTypes = {
    url: PropTypes.string,
    classNameImg: PropTypes.string
};

export default ImatgeAmbControlError;



// WEBPACK FOOTER //
// ./src/components/commons/imatgeAmbControlError.js